import { render, staticRenderFns } from "./VirtualScrollCrudAdvanced.vue?vue&type=template&id=2b1b9832&scoped=true"
import script from "./VirtualScrollCrudAdvanced.vue?vue&type=script&lang=js"
export * from "./VirtualScrollCrudAdvanced.vue?vue&type=script&lang=js"
import style0 from "./VirtualScrollCrudAdvanced.vue?vue&type=style&index=0&id=2b1b9832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b9832",
  null
  
)

export default component.exports